import * as Modals_en from './Modals.en.js';
import * as Modals_es from './Modals.es.js';

const ModalsTuple = [
  { type: 'Modals', language: 'en', object: Modals_en.default },
  { type: 'Modals', language: 'es', object: Modals_es.default },
];

export default ModalsTuple;
